export enum ImageryGeolocationalAccuracy {
  Regular = 'Regular',
  Rtk = 'RTK',
  Ppk = 'PPK',
  Mix = 'Mix: Regular, RTK, PPK',
}
